import { computed } from '@vue/composition-api';
import Notification from '@/orm/models/Notification/Notification';

export default function useNotifications() {
  const notifications = computed(() => Notification.all());

  return {
    notifications,
    hasNotifications: computed(() => notifications.value?.length > 0),
  };
}
